module.exports = __webpack_public_path__ + "static/flags/SH-fe88cb8b16985289d3f7b86169fe26c3.gif";